module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-practice ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (!_vm.loading) ? _c('main', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.props.acf.you_want_add_second_title_) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title_second)
    }
  })]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  })])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main190-562"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.props.acf.add_pages), function(links) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/patient-info/' + links.post_name + ''
      },
      domProps: {
        "innerHTML": _vm._s(links.post_title)
      }
    })], 1)
  }))])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.top_content)
    }
  })]), _c('div', {
    staticClass: "col-sm-3"
  })])])])]), _c('div', {
    staticClass: "saprater-mian"
  })]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-972643ee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/patient-info/patient-info.pug
// module id = 569
// module chunks = 1